'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _client = require('../client');

var _client2 = _interopRequireDefault(_client);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var newFolder = function newFolder() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  switch (action.type) {
    case 'INIT_NEW_FOLDER':
      return {
        name: '',
        visible: true
      };

    case 'CANCEL_NEW_FOLDER':
      return {
        name: '',
        visible: false
      };

    case 'CREATE_NEW_FOLDER':
      if (action.name) {
        _client2.default.folder.create({ name: action.name }).then(action.cb);
      }
      return {
        name: '',
        visible: false
      };

    default:
      return state;
  }
};

exports.default = newFolder;


//////////////////
// WEBPACK FOOTER
// ./client/reducers/newFolder.js
// module id = 118
// module chunks = 0